import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { AdRoutingModule } from '../ad/ad-routing.module';
import { AdsComponent } from '../ad/ads.component';
import { AdComponent } from '../ad/ad.component';
import { ClientsComponent } from '../ad/clients.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgSelectModule } from '@ng-select/ng-select';

import { AdService } from '../ad/ad.service';
import { NgxDropzoneModule } from 'ngx-dropzone';
@NgModule({

    imports: [FormsModule, CommonModule, ReactiveFormsModule, NgxDropzoneModule, AdRoutingModule, NgxPaginationModule, NgSelectModule],
    declarations: [AdsComponent, AdComponent, ClientsComponent],
    exports: [],
    providers: [AdService]
})
export class AdModule { }

